export const WatchlistControllerFactory = ({
  watchlistService,
}: {
  watchlistService: IWatchlistService;
}) => {
  const getWatchlist: IGetWatchlist = async ({ clinicId, floorIds }) => {
    const response = await watchlistService.getWatchlist({
      clinicId,
      floorIds,
      consentStatus: [1, 2],
    });
    if (response.success && response.data) {
      return {
        success: true,
        data: {
          data: response.data.data
            ? response.data.data.sort((a, b) => a.order - b.order)
            : [],
        },
      };
    }
    return { success: false, error: response.error };
  };

  const getWatchlistWithRR: IGetWatchlistWithRR = async ({
    clinicId,
    floorIds,
  }) => {
    const { success, data, error } = await watchlistService.getWatchlist({
      clinicId,
      floorIds,
      consentStatus: [1, 2],
    });

    if (success && data?.data) {
      return {
        success: true,
        data: data.data,
      };
    }
    return { success: false, error };
  };

  const putWatchlist: IPutWatchlist = async ({
    clinicId,
    watchlist,
    residentId,
    floorIds,
  }) => {
    const parseWatchlist: IPutWatchlistParam = [
      {
        resident_id: residentId,
        order: 1,
      },
      ...watchlist.map((item, index) => {
        return { resident_id: item.resident.id, order: index + 2 };
      }),
    ];
    const response = await watchlistService.putWatchlist({
      clinicId,
      watchlist: parseWatchlist,
    });
    let error;
    if (response.success) {
      const {
        success,
        data,
        error: resError,
      } = await getWatchlist({ clinicId, floorIds });

      if (success && data) {
        return { success: response.success, data: { data: data.data || [] } };
      }
      error = resError;
    }

    return { success: false, error: response.error || error };
  };

  const putMultipleIdsWatchlist: IPutMultipleIdsWatchlist = async ({
    clinicId,
    watchlist,
    residentIds,
    floorIds,
  }) => {
    let parseWatchlist: IPutWatchlistParam;
    if (typeof residentIds !== "number") {
      parseWatchlist = [
        ...residentIds.map((id, idIndex) => {
          return { resident_id: id, order: idIndex + 1 };
        }),
        ...watchlist.map((item, index) => {
          return {
            resident_id: item.resident.id,
            order: residentIds.length + index + 1,
          };
        }),
      ];
    }

    const response = await watchlistService.putWatchlist({
      clinicId,
      watchlist: parseWatchlist,
    });

    if (response.success) {
      const { success, data } = await getWatchlist({ clinicId, floorIds });
      if (success && data) {
        return { success: response.success, data: { data: data.data || [] } };
      }
    }

    return { success: false, error: response.error };
  };

  const reorderWatchlist: IReorderWatchlist = async ({
    clinicId,
    watchlist,
  }) => {
    const parseWatchlist: IPutWatchlistParam = watchlist.map((item, index) => ({
      resident_id: item.resident.id,
      order: index + 1,
    }));
    const response = await watchlistService.putWatchlist({
      clinicId,
      watchlist: parseWatchlist,
    });

    return response;
  };
  return {
    getWatchlist,
    putWatchlist,
    putMultipleIdsWatchlist,
    getWatchlistWithRR,
    reorderWatchlist,
  };
};
